import { isSemverGreaterOrEqualThan } from "./isSemverGreaterOrEqualThan.js";
/**
 * Checks if the current plugin version is compatible with a specified backend version.
 * @internal
 */
export function checkIfCompatibleWithPlugin(pluginName, requiredVersion) {
    const pluginVersion = getPluginVersion(pluginName);
    if (!pluginVersion)
        return false;
    const isCompatible = isSemverGreaterOrEqualThan(pluginVersion, requiredVersion);
    if (isCompatible)
        return true;
    // eslint-disable-next-line no-console
    console.warn(`[${pluginName}] request aborted. This request requires v${requiredVersion} on the desktop app backend. You are running version ${pluginVersion}.`);
    return false;
}
const getPluginVersion = (pluginName) => {
    var _a, _b, _c;
    return typeof window["todesktop"] === "object"
        ? (_c = (_b = (_a = window["todesktop"][pluginName]) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.packageJson) === null || _c === void 0 ? void 0 : _c.version
        : null;
};
